export default {"src":"/_next/static/media/DOCN.7069903a.svg","height":18,"width":18};